import { baseColors, themeByCSSVariables, typographyPxSizes, typographyRemSizes } from '@shared/lib/theme'

// === REM SIZES ===
export const buttonFontSizesRem = {
  '24': typographyRemSizes.size.captionS,
  '32': typographyRemSizes.size.captionS,
  '44': typographyRemSizes.size.captionM,
  '52': typographyRemSizes.size.captionM,
  '72': typographyRemSizes.size.captionL,
}

export const buttonLineHeightsRem = {
  '24': typographyRemSizes.lineHeight.captionXS,
  '32': typographyRemSizes.lineHeight.captionXS,
  '44': typographyRemSizes.lineHeight.captionM,
  '52': typographyRemSizes.lineHeight.captionM,
  '72': typographyRemSizes.lineHeight.captionL,
}

export const buttonPaddingsRem = {
  '24': '0.375rem',
  '32': '0.625rem',
  '44': '0.875rem',
  '52': '1.125rem',
  '72': '1.625rem',
}

export const buttonBorderRadiusesRem = {
  '24': '0.5rem',
  '32': '0.75rem',
  '44': '1rem',
  '52': '1rem',
  '72': '1.25rem',
}

export const buttonIconSizesRem = {
  '24': '0.625rem',
  '32': '0.625rem',
  '44': '1rem',
  '52': '1rem',
  '72': '1rem',
}

export const buttonSpinnerSizesRem = {
  '24': '0.75rem',
  '32': '0.75rem',
  '44': '1rem',
  '52': '1rem',
  '72': '1.25rem',
}

// === PX SIZES ===

export const buttonFontSizesPx = {
  '24': typographyPxSizes.size.captionS,
  '32': typographyPxSizes.size.captionS,
  '44': typographyPxSizes.size.captionM,
  '52': typographyPxSizes.size.captionM,
  '72': typographyPxSizes.size.captionL,
}

export const buttonLineHeightsPx = {
  '24': typographyPxSizes.lineHeight.captionXS,
  '32': typographyPxSizes.lineHeight.captionXS,
  '44': typographyPxSizes.lineHeight.captionM,
  '52': typographyPxSizes.lineHeight.captionM,
  '72': typographyPxSizes.lineHeight.captionL,
}

export const buttonPaddingsPx = {
  '24': '6px',
  '32': '10px',
  '44': '14px',
  '52': '18px',
  '72': '26px',
}

export const buttonBorderRadiusesPx = {
  '24': '8px',
  '32': '12px',
  '44': '16px',
  '52': '16px',
  '72': '20px',
}

export const buttonIconSizesPx = {
  '24': '10px',
  '32': '10px',
  '44': '16px',
  '52': '16px',
  '72': '16px',
}

export const buttonSpinnerSizesPx = {
  '24': '12px',
  '32': '12px',
  '44': '16px',
  '52': '16px',
  '72': '20px',
}

export const buttonBackgroundColorByVariant = (variant: 'primary' | 'secondary' | 'tertiary' | 'transparent') => {
  if (variant === 'primary') {
    return themeByCSSVariables.colors.background.accent
  }
  if (variant === 'secondary') {
    return themeByCSSVariables.colors.background.secondary
  }
  if (variant === 'tertiary') {
    return themeByCSSVariables.colors.background.tertiary
  }

  return 'transparent'
}

export const buttonTextColorByVariant = (variant: 'primary' | 'secondary' | 'tertiary' | 'transparent') => {
  if (variant === 'secondary') {
    return themeByCSSVariables.colors.text.primary
  }

  return baseColors.neutral_50
}
